import { Center, Text } from "@mantine/core";
import type { MsalAuthenticationResult } from "@azure/msal-react";

export const AuthenticationErrorPane = (error: MsalAuthenticationResult) => {
  return (
    <Center>
      <Text>
        An error occurred while signing in: {error.error?.errorMessage}
      </Text>
    </Center>
  );
};

export default AuthenticationErrorPane;
